import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const NotFound = () => {
  const location = useLocation();
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <Helmet>
        <title>Page Not Found - Safarnamah</title>
        <meta name="description" content="The page you're looking for doesn't exist. Explore our travel guides and destinations instead." />
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      
      <div className="max-w-md w-full text-center px-6">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-indigo-600 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Oops! Page Not Found
          </h2>
          <p className="text-gray-600 mb-8">
            The page you're looking for doesn't exist. But don't worry, there are plenty of amazing destinations to explore!
          </p>
        </div>
        
        <div className="space-y-4">
          <a 
            href="/"
            className="block w-full bg-indigo-600 text-white py-3 px-6 rounded-lg hover:bg-indigo-700 transition-colors duration-200"
          >
            Back to Home
          </a>
          
          <a 
            href="/places"
            className="block w-full bg-white text-indigo-600 border-2 border-indigo-600 py-3 px-6 rounded-lg hover:bg-indigo-50 transition-colors duration-200"
          >
            Explore Destinations
          </a>
          
          <a 
            href="/blog"
            className="block w-full bg-white text-indigo-600 border-2 border-indigo-600 py-3 px-6 rounded-lg hover:bg-indigo-50 transition-colors duration-200"
          >
            Read Travel Stories
          </a>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-4">
            Looking for something specific?
          </p>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <a href="/about" className="text-indigo-600 hover:underline">About Us</a>
            <a href="/contact" className="text-indigo-600 hover:underline">Contact</a>
            <a href="/plan-trip" className="text-indigo-600 hover:underline">Plan Trip</a>
            <a href="/faq" className="text-indigo-600 hover:underline">FAQ</a>
          </div>
        </div>
        
        {process.env.NODE_ENV === 'development' && (
          <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-sm text-yellow-800">
              <strong>Debug Info:</strong> Attempted to access: {location.pathname}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotFound;